export default __webpack_public_path__ + "static/media/09-framing-questions.61924057.png";